import React, { useEffect, useState } from 'react';
import Course from './Course';

const PopularCourses = () => {


    const [courses, setCourses] = useState([]);


    useEffect(() => {
        fetch('https://learn-for-tomorrow-server-side.vercel.app/courses')
            .then(res => res.json())
            .then(data => setCourses(data))
    }, [])


    return (
        <section>
            <h2 className='text-[2.5em] text-center font-semibold mt-8 mb-28' >Explore Our Popular Online Courses</h2>

            <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-6'>
                {
                    courses?.map((course) => <Course
                        key={course.id}
                        course={course}
                    ></Course>)
                }
            </div>

        </section>
    );
};

export default PopularCourses;